import { getWebApp, hapticSelection } from '../telegram/webapp.js';

/** Trigger a subtle long-press haptic with a browser vibrate fallback. */
export function triggerLongPressHaptic(): void {
  try {
    const webApp = getWebApp();
    if (webApp?.HapticFeedback) {
      hapticSelection();
      return;
    }
  } catch {
    // ignore and continue to fallback
  }

  try {
    if (typeof navigator !== 'undefined' && typeof navigator.vibrate === 'function') {
      navigator.vibrate(35);
    }
  } catch {
    // vibrate unavailable/blocked
  }
}

export type HapticKind = 'tap' | 'select' | 'success' | 'error';

const VIBRATE_PATTERNS: Record<HapticKind, number | number[]> = {
  tap: 12,
  select: 8,
  success: [10, 40, 18],
  error: [30, 50, 30],
};

/**
 * Light UI feedback: Telegram HapticFeedback inside the mini app, otherwise
 * `navigator.vibrate` where supported. Silently does nothing when unavailable
 * or when the user prefers reduced motion.
 */
export function hapticFeedback(kind: HapticKind): void {
  try {
    if (typeof window !== 'undefined' && window.matchMedia?.('(prefers-reduced-motion: reduce)').matches) return;
    const webApp = getWebApp();
    if (webApp?.HapticFeedback) {
      if (kind === 'tap') webApp.HapticFeedback.impactOccurred('light');
      else if (kind === 'select') webApp.HapticFeedback.selectionChanged();
      else webApp.HapticFeedback.notificationOccurred(kind);
      return;
    }
    if (typeof navigator !== 'undefined' && typeof navigator.vibrate === 'function') {
      navigator.vibrate(VIBRATE_PATTERNS[kind]);
    }
  } catch {
    // haptics unavailable/blocked
  }
}
